import { NavLink, Outlet, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuthStore, isAdminRole, isMasterRole } from '../store';

export function Layout({ children }: { children: ReactNode }) {
  const location = useLocation();
  const user = useAuthStore((s) => s.user);
  const isMaster = isMasterRole(user?.role);
  const isAdmin = isAdminRole(user?.role);
  const isMasterArea = location.pathname.startsWith('/master');
  const isAdminArea = location.pathname.startsWith('/admin');

  return (
    <div className="flex min-h-full flex-col">
      <main className="flex-1 px-4 py-4 pb-24">{children}</main>
      <nav className="fixed inset-x-0 bottom-0 z-20 border-t border-tg-hint/20 bg-tg-bg pb-[env(safe-area-inset-bottom)]">
        <div className="mx-auto grid max-w-md grid-cols-4 gap-1 px-2 py-1.5 text-xs">
          {isAdminArea && isAdmin ? (
            <>
              <Tab to="/admin/services" label="Услуги" icon="🧰" />
              <Tab to="/admin/masters" label="Мастера" icon="👥" />
              <Tab to="/" label="Клиент" icon="🏠" />
              <Tab to="/profile" label="Профиль" icon="👤" />
            </>
          ) : isMasterArea && isMaster ? (
            <>
              <Tab to="/master/calendar" label="Календарь" icon="📅" />
              <Tab to="/master/bookings" label="Записи" icon="📋" />
              <Tab to="/master/schedule" label="Часы" icon="⏰" />
              <Tab to="/master/settings" label="Настройки" icon="⚙️" />
            </>
          ) : (
            <>
              <Tab to="/" label="Главная" icon="🏠" />
              <Tab to="/services" label="Услуги" icon="💅" />
              <Tab to="/my-bookings" label="Записи" icon="📋" />
              <Tab to="/profile" label="Профиль" icon="👤" />
            </>
          )}
        </div>
      </nav>
    </div>
  );
}

Layout.Outlet = function LayoutOutlet() {
  return <Outlet />;
};

function Tab({ to, label, icon }: { to: string; label: string; icon: string }) {
  return (
    <NavLink
      to={to}
      end
      className={({ isActive }) =>
        `flex flex-col items-center gap-0.5 rounded-tg px-2 py-1 transition ${
          isActive ? 'text-tg-link font-semibold' : 'text-tg-hint'
        }`
      }
    >
      <span className="text-lg leading-none">{icon}</span>
      <span>{label}</span>
    </NavLink>
  );
}
